import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { NikoFacilityOrderClinicalReviewPreviewViewStore } from "../stores";
import { NikoFacilityOrderClinicalReviewPreviewTemplate } from "themes/application/niko-facility-order-clinical-review/pages";

@setCurrentView(rootStore => new NikoFacilityOrderClinicalReviewPreviewViewStore(rootStore), "nikoFacilityOrderClinicalReviewPreviewViewStore")
@observer
class NikoFacilityOrderClinicalReviewPreview extends React.Component {
	render() {
		return <NikoFacilityOrderClinicalReviewPreviewTemplate {...this.props} />;
	}
}

export default NikoFacilityOrderClinicalReviewPreview;